<template>
  <v-autocomplete
    v-model="inputedValue"
    :items="items"
    item-text="label"
    item-value="value"
    :placeholder="$t('common.input_unselected_2')"
    class="original-selectbox"
    :return-object="returnObject"
    outlined
    dense
    hide-details
    :height="height"
    width="80%"
    clearable
    :disabled="disabled"
    :filled="disabled"
    @change="change"
    :no-data-text="$t('common.common_no-data')"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {
      require: true,
      default: () => ({})
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    height: { default: '32px' },
    disabled: { default: false }
  },
  data: () => ({}),
  created() {},
  methods: {
    ...mapGetters('Supplier', ['getSuggestedReceivingLocationListFromState']),
    change(newValue) {
      if (this.returnObject && !newValue) {
        newValue = {
          label: '',
          value: null
        }
      }

      this.$emit('change', newValue)
    }
  },
  computed: {
    items() {
      return this.getSuggestedReceivingLocationListFromState().map((ele) => {
        return {
          label: ele.location,
          value: ele.suggestedReceivingLocationId
        }
      })
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (this.returnObject && !newValue) {
          newValue = {
            label: '',
            value: null
          }
        }

        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
